export default "__VITE_ASSET__f685b1e7__"